import React, { useState, useEffect, useContext } from "react";
import ChatWindow from "./ChatWindow";
import { UserContext } from "../../contexts/UserContext";
import PrivateChatWrapper from "./PrivateChatWrapper";
import CorporateChatWrapper from "./CorporateChatWrapper";
import ChatWindowView from "./ChatWindowView";
import { usePublicChat } from "./hooks/usePublicChat";

const ChatWrapper = ({
  event,
  page,
  showPublicChat,
  showCorporateChat,
  corporateOrganization,
}) => {
  const [urlParams, setUrlParams] = useState(null);

  useEffect(() => {
    if (event && page) {
      setUrlParams({
        eventSlug: event,
        pageSlug: page,
        organizationSlug: corporateOrganization?.slug ?? "",
      });
    }
  }, [event, page, corporateOrganization]);

  const { me } = useContext(UserContext);
  const { publicChatList } = usePublicChat({ me, urlParams });

  return (
    <>
      {me && urlParams && (
        <div className="d-flex flex-row-reverse me-5 chat-wrapper">
          {showPublicChat &&
            publicChatList &&
            Object.entries(publicChatList).map((inbox) => {
              const [inboxUUID, data] = inbox;
              return (
                <ChatWindow {...data.props}>
                  {(props) => <ChatWindowView {...props} />}
                </ChatWindow>
              );
            })}

          <PrivateChatWrapper {...{ urlParams, me }} />

          {showCorporateChat && (
            <CorporateChatWrapper
              {...{ urlParams, me, corporateOrganization }}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ChatWrapper;
